// Module
var code = "<abx-type-ahead abx-value=\"vm.value\" abx-options=\"vm.suggestions\" abx-on-select=\"vm.onSelect({ $event: $event })\" abx-on-change=\"vm.handleChange($event)\" abx-on-focus=\"vm.onFocus()\" abx-on-blur=\"vm.onBlur()\" abx-disabled=\"vm.disabled\"></abx-type-ahead> ";
// Exports
module.exports = code;